import { Outlet } from 'react-router-dom'
import { useAuthStore } from '../../stores/auth.store'

export function AppShell() {
  const user = useAuthStore((s) => s.user)
  const clearAuth = useAuthStore((s) => s.clearAuth)

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <aside style={{ width: 220, backgroundColor: '#001529', color: '#fff', padding: '16px 0', flexShrink: 0 }}>
        <div style={{ padding: '0 16px', marginBottom: 24 }}>
          <h2 style={{ margin: 0, fontSize: 18, color: '#fff' }}>CRM</h2>
        </div>
        <nav>
          <div style={{ padding: '10px 16px', color: 'rgba(255,255,255,0.65)', fontSize: 14 }}>Objects (loading...)</div>
        </nav>
      </aside>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <header style={{ height: 48, backgroundColor: '#fff', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '0 16px' }}>
          <span style={{ marginRight: 16, fontSize: 14, color: '#666' }}>{user?.display_name || user?.username}</span>
          <button onClick={clearAuth} style={{ fontSize: 14, color: '#1677ff', background: 'none', border: 'none', cursor: 'pointer' }}>Logout</button>
        </header>
        <main style={{ flex: 1, padding: 24, backgroundColor: '#f5f5f5' }}>
          <Outlet />
        </main>
      </div>
    </div>
  )
}
